import { GeneratedDocument } from "models/GeneratedDocument";
import { OutputDocumentViewModel } from "models/OutputDocumentViewModel";
import { createContext } from "react";

export interface OutputDocumentsPanelContextProps {
  showOutputDocumentsPanel: boolean;
  setShowOutputDocumentsPanel: (open: boolean) => void;
  selectedOutputDocument: OutputDocumentViewModel | undefined;
  setSelectedOutputDocument: (document: OutputDocumentViewModel | undefined) => void;
  showConfirmDialog: boolean;
  setShowConfirmDialog: (show: boolean) => void;
  onSelectDocument: (document: OutputDocumentViewModel, meetingId: number, agendaItemId: number | undefined) => void;
  hideConfirmDialog: () => void;
  isGenerating: boolean;
  generatedDocuments: GeneratedDocument[] | undefined;
}

export const OutputDocumentsPanelContext = createContext({} as OutputDocumentsPanelContextProps);
